module.exports = __webpack_public_path__ + "img/6-detail.a25ac7c2.jpg";